import { getAppConfig } from "services/configService";
import { GET_BLOB } from "services/httpService";

const apiUrl = () => {
  return getAppConfig().InvoiceApiUrl;
};

export const getInvoice = (requestInfo, orderCode) => {
  return GET_BLOB(requestInfo, apiUrl() + `/v1/invoiceGroupFiles/me/${orderCode}`);
};
